import OverallPortfolioTimeline from "pages/PanelPage/components/selectedAssessment/assessmentResults/takerResults/OverallPortfolioTimeline/OverallPortfolioTimeline";

export default OverallPortfolioTimeline;
